module.exports = __webpack_public_path__ + "media/images/webpage/hotels/1321/floorguide/course-3-photo-7-d818e849669d31b76beff299e60a556f.webp";